import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TalentProfileRoutingModule } from './talent-profile-routing.module';
import { TalentProfileContainerComponent } from "./talent-profile-container/talent-profile-container.component";
import { EmploymentOpportunitiesComponent } from "./employment-opportunities/employment-opportunities.component";
import { EmploymentAuthorizationComponent } from "./employment-authorization/employment-authorization.component";
import { EmploymentPreferencesComponent } from "./employment-preferences/employment-preferences.component";
import { QuickApplyModule } from "../quick-apply/quick-apply.module";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { AngularSvgIconModule } from "angular-svg-icon";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatDatepickerModule } from "@angular/material/datepicker";

import { EmploymentSalaryComponent } from "./employment-salary/employment-salary.component";
import { EmploymentSplashPageComponent } from "./employment-splash-page/employment-splash-page.component";
import { TalentEeocComponent } from "./talent-eeoc/talent-eeoc.component";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { InitialInterviewModule } from '../initial-interview/initial-interview.module';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DatePickerComponent } from '../shared/components/date-picker/date-picker.component';
import { ConfirmationModalComponent } from "../shared/components/confirmation-modal/confirmation-modal.component";

@NgModule({
  declarations: [
    EmploymentSplashPageComponent,
    TalentProfileContainerComponent,
    EmploymentOpportunitiesComponent,
    EmploymentPreferencesComponent,
    EmploymentSalaryComponent,
    EmploymentAuthorizationComponent,
    TalentEeocComponent,
  ],
  imports: [
    MatButton,
    MatFormFieldModule,
    MatButtonModule,
    MatLabel,
    MatInputModule,
    AngularSvgIconModule.forRoot(),
    CommonModule,
    TalentProfileRoutingModule,
    QuickApplyModule,
    InitialInterviewModule,
    TranslateModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatRadioModule,
    MatChipsModule,
    CommonModule,
    MatIconModule,
    MatDatepickerModule,
    DatePickerComponent,
    MatOptionModule,
    MatSelectModule,
    ReactiveFormsModule,
    ConfirmationModalComponent,
    MatProgressSpinnerModule,
  ],
  exports: [
    DatePickerComponent,
    EmploymentPreferencesComponent,
    EmploymentSplashPageComponent,
    EmploymentOpportunitiesComponent,
    EmploymentAuthorizationComponent,
    EmploymentSalaryComponent,
    TalentEeocComponent,
  ],
})
export class TalentProfileModule { }
